module.exports = __webpack_public_path__ + "img/night-city-fence.c4e1195e.jpg";